/**
 * AWS Amplify Configuration
 * Requirements: 1.4, 1.7, 3.2
 */

export const isLocalMode = import.meta.env.VITE_LOCAL_MODE === 'true';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-west-2_XaERdoNbo',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '13fbi72s8kmu0qmqprg0g081gn',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || 'skillsnap-auth.auth.us-west-2.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            import.meta.env.VITE_REDIRECT_SIGN_IN || 'https://app.skillsnap.me/callback'
          ],
          redirectSignOut: [
            import.meta.env.VITE_REDIRECT_SIGN_OUT || 'https://app.skillsnap.me'
          ],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export const apiConfig = {
  baseUrl: isLocalMode
    ? (import.meta.env.VITE_API_URL || 'http://localhost:5001')
    : (import.meta.env.VITE_API_URL || 'https://r29f280jj8.execute-api.us-west-2.amazonaws.com/v1'),
};
